import { Link } from 'react-router-dom'
import notFoundImage from '../../assets/images/robot-assistant-sad.png'
export const NoIdeaFound = ({ heading, desc }) => {
    return (
        <>
            <div className='col-12 col-lg-5'>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-3">
                                <img
                                    src={notFoundImage}
                                    alt="img" width={"80px"}
                                />
                            </div>
                            <div className="col-9">
                                <h3 className="mb-5 font-weight-600">{heading}</h3>
                                <p className="mb-20">Check this spot later…</p>
                                <Link to="/post-idea" className="btn btn-primary text-white rounded-10 font-11"><i
                                    className="fas fa-lightbulb mr-1"></i>Post your idea</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}